import React from 'react';
import { Button, Tooltip, IconButton, SvgIconProps } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import clsx from 'clsx';
import { CustomTypography } from '../custom/CustomTypography';
import styles from './SidePanel.module.css';

interface ISidePanelHeaderProps {
  title: string;
  onClose: () => void;
  action?: () => void;
  actionText?: string;
  ActionIcon?: React.ElementType<SvgIconProps>;
}

export const SidePanelHeader: React.FC<ISidePanelHeaderProps> = ({
  title,
  onClose,
  action,
  actionText,
  ActionIcon,
}) => {
  return (
    <div className={styles.header}>
      <div className={styles.container}>
        <CustomTypography className={clsx('text-24-medium', 'font-golos')}>
          {title}
        </CustomTypography>
        {action && (
          <Tooltip title={actionText || 'Создать'} className={styles.tooltip}>
            <Button
              data-id="side-panel-create-button"
              variant="custom"
              component="label"
              color="secondary"
              onClick={action}
              startIcon={
                ActionIcon ? (
                  <ActionIcon className={styles.buttonIcon} />
                ) : (
                  <PostAddOutlinedIcon className={styles.buttonIcon} />
                )
              }
            />
          </Tooltip>
        )}
      </div>
      <IconButton
        data-id="side-panel-close-button"
        onClick={onClose}
      >
        <CloseOutlinedIcon />
      </IconButton>
    </div>
  );
};
